import React, { useState, useEffect } from "react";

const JobPortal = () => {
  const [countries, setCountries] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [jobDetails, setJobDetails] = useState(null);
  const [filter, setFilter] = useState("");
  const [country, setCountry] = useState("");
  const [pagination, setPagination] = useState({ pageNumber: 1, numPages: 0, count: 0 });
  const [loading, setLoading] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);  // Track the selected job ID
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);  // Store job data to show in the modal

  // Function to handle Apply Now click
  const handleApplyNowClick = (jobCode, jobTitle, jobId) => {
    setModalData({ jobCode, jobTitle, jobId });
    setIsModalOpen(true);  // Open the modal
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };
  
  useEffect(() => {
    fetchCountries();
    fetchJobDetails(1);
  }, []);

  const fetchCountries = async () => {
    try {
      const api = `/api/getCountries`;
      const response = await fetch(api, { method: "GET", headers: { "Content-Type": "application/json" } });
      if (!response.ok) throw new Error("Failed to fetch countries");
      const data = await response.json();
      setCountries(data);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  const fetchJobDetails = async (page) => {
    setLoading(true);
    try {
      const api = `/api/jobdetails?filter=${filter}&country=${country}&page=${page}`;
      const response = await fetch(api, { method: "GET", headers: { "Content-Type": "application/json" } });
      if (!response.ok) throw new Error("Failed to fetch job details");
      const data = await response.json();
      setJobs(data.result);
      setPagination({ pageNumber: data.page_number, numPages: data.num_pages, count: data.count });
      if (data.result.length > 0) {
        fetchJobInfo(data.result[0].id);  // Fetch details of the first job
      }
    } catch (error) {
      console.error("Error fetching job details:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchJobInfo = async (id) => {
    try {
      const api = `/api/invjobdetails?id=${id}`;
      const response = await fetch(api, { method: "GET", headers: { "Content-Type": "application/json" } });
      if (!response.ok) throw new Error("Failed to fetch job info");
      const data = await response.json();
      setJobDetails(data);
    } catch (error) {
      console.error("Error fetching job info:", error);
    }
  };

  const handleFilterChange = (e) => setFilter(e.target.value);

  const handleCountryChange = (e) => setCountry(e.target.value);

  const handleFilterSubmit = () => {
    if (!filter.trim() && !country.trim()) {
      alert("Please provide a filter or select a country.");
      return;
    }
    fetchJobDetails(1);
  };

  // Modified get_select function to work with React state
  const handleJobClick = (id) => {
    setSelectedJobId(id);  // Update the selected job ID
    fetchJobInfo(id);  // Fetch job info when clicked
  };

  const handlePagination = (page) => fetchJobDetails(page);

  return (
    <>
      <div className="job_section">
        <div className="job_data">
          <div className="container">
            {/* Filter Section */}
            <div className="filter_section">
              <div className="filter_data">
                <div className="row">
                  <div className="col-lg-5">
                    <div className="filter_input">
                      <i className="fa fa-search"></i>
                      <input
                        type="text"
                        name="filter"
                        id="filter"
                        placeholder="Job Title..."
                        value={filter}
                        onChange={handleFilterChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="filter_input">
                      <i className="fa fa-map-marker-alt"></i>
                      <select name="country" id="country" value={country} onChange={handleCountryChange}>
                        <option value="">--choose--</option>
                        {countries.map((ctr) => (
                          <option key={ctr.id} value={ctr.id}>
                            {ctr.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="filter_input" style={{ border: "none", padding: "0px" }}>
                      <button type="button" name="data_filter" id="data_filter" onClick={handleFilterSubmit}>
                        <span>Filter</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Career Section */}
            <div className="career_section">
              <div className="career_data">
                <div className="containers">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="career_left">
                        <div className="career_left_head">
                          <p>
                            <span>{pagination.pageNumber}</span> - <span>{pagination.numPages}</span> of <span>{pagination.count}</span> Jobs
                          </p>
                        </div>
                        <div className="career_list">
                          <ul>
                            {jobs.map((job) => (
                              <li
                                key={job.id}
                                onClick={() => handleJobClick(job.id)}
                                className={job.id === selectedJobId ? 'active' : ''}
                              >
                                <div className="clist_skills">
                                  <p className="skills">Job Code : {job.job_code}</p>
                                </div>
                                <div className="clist_header">
                                  <p className="title">{job.position_title}</p>
                                </div>
                                <div className="clist_skills">
                                  <p className="skills">Country : {job.country}</p>
                                </div>
                                <div className="clist_skills">
                                  <p className="skills">State : {job.state}</p>
                                </div>
                                <div className="clist_skills">
                                  <p className="skills">Skills : {job.skills}</p>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="career_page">
                          {pagination.pageNumber > 1 && (
                            <button className="link_left" onClick={() => handlePagination(pagination.pageNumber - 1)}>
                              Previous
                            </button>
                          )}
                          {pagination.pageNumber < pagination.numPages && (
                            <button className="link_right" onClick={() => handlePagination(pagination.pageNumber + 1)}>
                              Next
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <div className="career_right">
                        {loading ? (
                          <p>Loading...</p>
                        ) : (
                          jobDetails && (
                            <div className="career_details">
                              <div style={{ width: "100%", float: "left", borderBottom: "1px solid #ccc", marginBottom: "10px" }}>
                                <div style={{ float: "left" }}>
                                  <p className="jtitle">
                                    {jobDetails.job_code}-{jobDetails.public_job_title}
                                  </p>
                                  <p className="jexp">
                                    <b>Experience :</b> {jobDetails.experience}
                                  </p>
                                  <p className="jexp">
                                    <b>Country :</b> {jobDetails.country}
                                  </p>
                                  <p className="jexp">
                                    <b>State :</b> {jobDetails.state}
                                  </p>
                                </div>
                                <div style={{ float: "right" }}>
                                <button className="jlink"  onClick={() => handleApplyNowClick( jobDetails.id,
                                        jobDetails.public_job_title, 
                                        jobDetails.job_code)}> Apply Now
                                </button>
                                </div>
                              </div>
                              <p className="jdes">
                                <b>Description :</b> {jobDetails.public_job_desc}
                              </p>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobPortal;
